// //client/src/components/QuestionCard.tsximport React from "react";
import {
  Box,
  VStack,
  Text,
  Radio,
  RadioGroup,
  useBreakpointValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { QuizQuestion } from "../data/quizData";

const MotionDiv = motion.div;

interface QuestionCardProps {
  question: QuizQuestion;
  selectedAnswer: number | null;
  onAnswerSelect: (answerIndex: number) => void;
  isDisabled?: boolean;
  bg?: string;
  color?: string;
}

export default function QuestionCard({
  question,
  selectedAnswer,
  onAnswerSelect,
  isDisabled = false,
  bg = "rgba(65, 62, 62, 0.17)",
  color = "white",
}: QuestionCardProps) {
  // Responsive values
  const cardPadding = useBreakpointValue({ base: 4, md: 6 });
  const questionFontSize = useBreakpointValue({
    base: "xl",
    md: "2xl",
  });
  const optionFontSize = useBreakpointValue({ base: "md", md: "lg" });
  const radioSize = useBreakpointValue({ base: "md", md: "lg" });
  const spacing = useBreakpointValue({ base: 4, md: 6 });

  return (
    <Box width="100%">
      <MotionDiv
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        style={{
          width: "100%",
          maxWidth: "100%",
          backgroundColor: bg,
          padding: `${cardPadding}px`,
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          border: "2px solid",
          borderColor: "purple.100",
        }}
      >
        <VStack spacing={spacing} align="stretch">
          <Text
            fontSize={questionFontSize}
            fontWeight="bold"
            color={color}
            textAlign="center"
            px={2}
            lineHeight="tall"
            fontFamily="'Comic Neue', cursive"
          >
            {question.text}
          </Text>

          <RadioGroup
            value={selectedAnswer?.toString()}
            onChange={(value) => onAnswerSelect(parseInt(value))}
            isDisabled={isDisabled}
          >
            <VStack spacing={spacing} align="stretch" px={1}>
              {question.options.map((option, index) => (
                <Radio
                  key={index}
                  value={index.toString()}
                  size={radioSize}
                  colorScheme="purple"
                  borderColor="purple.300"
                  _hover={{
                    borderColor: "purple.400",
                  }}
                >
                  <Text
                    fontSize={optionFontSize}
                    color="gray.200"
                    fontWeight="medium"
                    fontFamily="'Comic Neue', cursive"
                    pl={2}
                  >
                    {option.text}
                  </Text>
                </Radio>
              ))}
            </VStack>
          </RadioGroup>
        </VStack>
      </MotionDiv>
    </Box>
  );
}